import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3" }

import { inject, ref } from "vue";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import AnimatedBox from "../AnimatedBox.vue";
import DMSuiteIcon from "@/components/iconify/DMSuiteIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'StatsCard',
  props: {
    stats: {},
    title: {},
    description: {},
    icon: {},
    iconWrapClass: {},
    iconClass: {},
    trendText: {},
    trendClass: {},
    tooltip: {}
  },
  setup(__props: any) {



const comfortMode = inject<any>("comfortMode", ref("comfortable"));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AnimatedBox, null, {
    default: _withCtx(() => [
      _createVNode(_unref(Card), {
        class: _normalizeClass(
        _unref(cn)(
          'group flex flex-col justify-between w-full rounded-3xl border border-slate-100 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_36px_rgba(15,23,42,0.05)] cursor-pointer text-left',
          _unref(comfortMode) === 'comfortable' ? 'h-[13rem] p-6' : 'h-[11rem] p-5'
        )
      ),
        title: __props.tooltip
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(_unref(comfortMode) === 'comfortable' ? 'space-y-5' : 'space-y-4')
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: _normalizeClass(
              _unref(cn)(
                'flex items-center justify-center border shrink-0',
                _unref(comfortMode) === 'comfortable'
                  ? 'h-12 w-12 rounded-2xl'
                  : 'h-10 w-10 rounded-xl',
                __props.iconWrapClass || 'bg-slate-50 text-slate-600 border-slate-100'
              )
            )
              }, [
                (typeof __props.icon === 'string')
                  ? (_openBlock(), _createBlock(DMSuiteIcon, {
                      key: 0,
                      icon: __props.icon,
                      size: _unref(comfortMode) === 'comfortable' ? 24 : 22,
                      "custom-class": __props.iconClass
                    }, null, 8, ["icon", "size", "custom-class"]))
                  : (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), {
                      key: 1,
                      class: _normalizeClass(
                _unref(cn)(
                  _unref(comfortMode) === 'comfortable' ? 'size-6' : 'size-5',
                  __props.iconClass
                )
              )
                    }, null, 8, ["class"]))
              ], 2),
              _createElementVNode("span", {
                class: _normalizeClass(
              _unref(cn)(
                'tracking-tight',
                _unref(comfortMode) === 'comfortable'
                  ? 'text-base font-bold text-slate-900'
                  : 'text-sm font-extrabold text-slate-800'
              )
            )
              }, _toDisplayString(__props.title), 3)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_unref(comfortMode) === 'comfortable' ? 'space-y-1.5' : 'space-y-1')
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(
              _unref(cn)(
                'font-black text-slate-800 tracking-tight leading-none',
                _unref(comfortMode) === 'comfortable' ? 'text-4xl' : 'text-3xl'
              )
            )
              }, _toDisplayString(__props.stats), 3),
              _createElementVNode("p", {
                class: _normalizeClass(
              _unref(cn)(
                _unref(comfortMode) === 'comfortable'
                  ? 'text-sm font-medium text-slate-600'
                  : 'text-[0.82rem] font-extrabold text-slate-400'
              )
            )
              }, _toDisplayString(__props.description), 3)
            ], 2)
          ], 2),
          (__props.trendText)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(
          _unref(cn)(
            'font-bold mt-1 flex items-center gap-1',
            _unref(comfortMode) === 'comfortable' ? 'text-xs' : 'text-[0.76rem]',
            __props.trendClass || 'text-slate-400'
          )
        )
              }, _toDisplayString(__props.trendText), 3))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class", "title"])
    ]),
    _: 1
  }))
}
}

})